/**
 * Naming convention:
 * {category, ui element}_{what_it_does}_{what_it_does}
 *
 * examples:
 * icon_youtube
 * language_selector_dropdown_label
 * color_theme_brown_dark
 * background_color_brown_dark
 * text_color_brown_dark
 */
export const DICTIONARY_MAP = {
  language_selector: {
    language_selector_dropdown_label: "language_selector_dropdown_label",
  },
  map: {
    map_direction_link: "map_direction_link",
  },
  footer: {
    footer_probably_the_best: "footer_probably_the_best",
    footer_beer_in_the_world: "footer_beer_in_the_world",
  },
  faq_module: {
    faq_module_question_text: "faq_module_question_text",
    faq_module_answer_text: "faq_module_answer_text",
    faq_module_button_text: "faq_module_button_text",
  },
  eventcard_module: {
    eventcard_price_text: "eventcard_price_text",
    eventcard_today_text: "eventcard_today_text",
  },
  scroll_down: "scroll_down",
  contactinformation_module: {
    phone_label: "phone_label",
  },
  opening_hours: {
    open: "opening_hours_open",
  },
  nps_module: {
    not_likely_label: "not_likely_label",
    very_likely_label: "very_likely_label",
  },
  storyslider: {
    storyslider_click_to_explore_text: "storyslider_click_to_explore_text",
    storyslider_rotate_text: "storyslider_rotate_text",
  },
  kiosk: {
    bottle_details_find: "bottle_details_find",
    bottle_details_find_entry: "bottle_details_find_entry",
    bottle_details_find_exit: "bottle_details_find_exit",
    bottle_details_find_section: "bottle_details_find_section",
    bottle_details_find_shelf: "bottle_details_find_shelf",
    bottle_details_find_text: "bottle_details_find_text",
    bottle_details_next: "bottle_details_next",
    bottle_details_prev: "bottle_details_prev",
    bottle_details_view: "bottle_details_view",
    bottle_details_section: "bottle_details_section",
    bottle_details_shelf: "bottle_details_shelf",
    bottle_details_placement: "bottle_details_placement",
    bottle_details_back: "bottle_details_back",
    bottle_details_nofound: "bottle_details_nofound",
    bottle_details_nofound_text: "bottle_details_nofound_text",
    kiosk_placeholder: "kiosk_placeholder",
    kiosk_filters_abv: "kiosk_filters_abv",
    kiosk_filters_alcohol: "kiosk_filters_alcohol",
    kiosk_filters_brand: "kiosk_filters_brand",
    kiosk_filters_brewery: "kiosk_filters_brewery",
    kiosk_filters_close: "kiosk_filters_close",
    kiosk_filters_country: "kiosk_filters_country",
    kiosk_filters_sizegroup: "kiosk_filters_sizegroup",
    kiosk_filters_themes: "kiosk_filters_themes",
    kiosk_filters_favourites: "kiosk_filters_favourites",
    kiosk_filters_filters: "kiosk_filters_filters",
    kiosk_filters_remove_filters: "kiosk_filters_remove_filters",
    kiosk_filters_oldest: "kiosk_filters_oldest",
    kiosk_filters_size: "kiosk_filters_size",
    kiosk_filters_unique: "kiosk_filters_unique",
    kiosk_filters_year: "kiosk_filters_year",
    kiosk_filters_imported_by: "kiosk_filters_imported_by",
    kiosk_filters_licensed_by: "kiosk_filters_licensed_by",
    kiosk_filters_loadmore: "kiosk_filters_loadmore",
    kiosk_filters_sortby: "kiosk_filters_sortby",
    kiosk_filters_sortby_brand_az: "kiosk_filters_sortby_brand_az",
    kiosk_filters_sortby_brand_za: "kiosk_filters_sortby_brand_za",
    kiosk_filters_sortby_beer_az: "kiosk_filters_sortby_beer_az",
    kiosk_filters_sortby_beer_za: "kiosk_filters_sortby_beer_za",
    kiosk_filters_sortby_alcohol_high: "kiosk_filters_sortby_alcohol_high",
    kiosk_filters_sortby_alcohol_low: "kiosk_filters_sortby_alcohol_low",
    kiosk_filters_sortby_newest: "kiosk_filters_sortby_newest",
    kiosk_filters_sortby_oldest: "kiosk_filters_sortby_oldest",
    kiosk_bottle_found: "kiosk_bottle_found",
    kiosk_bottles_found: "kiosk_bottles_found",
  },
  global_compliance: {
    global_compliance_manage_cookies_button:
      "global_compliance_manage_cookies_button",
  },
  digital_memories: {
    active_digital_memories_headline: "active_digital_memories_headline",
    active_digital_memories_text: "active_digital_memories_text",
    digital_memories_bottles_headline: "digital_memories_bottles_headline",
    digital_memories_bottles_text: "digital_memories_bottles_text",
    digital_memories_bottles_link_text: "digital_memories_bottles_link_text",
    digital_memories_bottles_link_url: "digital_memories_bottles_link_url",
    digital_memories_brewhouse_headline: "digital_memories_brewhouse_headline",
    digital_memories_brewhouse_text: "digital_memories_brewhouse_text",
    digital_memories_liverpool_headline: "digital_memories_liverpool_headline",
    digital_memories_liverpool_text: "digital_memories_liverpool_text",
    digital_memories_code_button_text: "digital_memories_code_button_text",
    digital_memories_code_headline: "digital_memories_code_headline",
    digital_memories_code_text: "digital_memories_code_text",
    digital_memories_flavour_heading: "digital_memories_flavour_heading",
    digital_memories_flavour_text: "digital_memories_flavour_text",
    digital_memories_flavour_yourbestmatch:
      "digital_memories_flavour_yourbestmatch",
    digital_memories_flavour_yeasttype: "digital_memories_flavour_yeasttype",
    digital_memories_flavour_hoparoma: "digital_memories_flavour_hoparoma",
    digital_memories_flavour_alcohol: "digital_memories_flavour_alcohol",
    digital_memories_flavour_alcohol_low:
      "digital_memories_flavour_alcohol_low",
    digital_memories_flavour_alcohol_high:
      "digital_memories_flavour_alcohol_high",
    digital_memories_flavour_color: "digital_memories_flavour_color",
    digital_memories_flavour_color_light:
      "digital_memories_flavour_color_light",
    digital_memories_flavour_color_dark: "digital_memories_flavour_color_dark",
    digital_memories_flavour_bitterness: "digital_memories_flavour_bitterness",

    digital_memories_future_headline: "digital_memories_future_headline",
    digital_memories_future_text: "digital_memories_future_text",
    digital_memories_future_button_text: "digital_memories_future_button_text",
    digital_memories_future_link_1: "digital_memories_future_link_1",
    digital_memories_future_link_2: "digital_memories_future_link_2",
    digital_memories_future_link_3: "digital_memories_future_link_3",
    digital_memories_future_video_1_link:
      "digital_memories_future_video_1_link",
    digital_memories_future_video_2_link:
      "digital_memories_future_video_2_link",
    digital_memories_future_video_3_link:
      "digital_memories_future_video_3_link",
    digital_memories_hybrid_headline: "digital_memories_hybrid_headline",
    digital_memories_hybrid_text: "digital_memories_hybrid_text",
    digital_memories_process_headline: "digital_memories_process_headline",
    digital_memories_process_text: "digital_memories_process_text",
    digital_memories_process_video_apprentice:
      "digital_memories_process_video_apprentice",
    digital_memories_process_video_brewer:
      "digital_memories_process_video_brewer",
    digital_memories_process_video_masterbrewer:
      "digital_memories_process_video_masterbrewer",
    digital_memories_label_text: "digital_memories_label_text",
    digital_memories_label_headline: "digital_memories_label_headline",
    digital_memories_mission_headline: "digital_memories_mission_headline",
    digital_memories_mission_text: "digital_memories_mission_text",
    download_module_button_text: "download_module_button_text",
    no_digital_memories_headline: "no_digital_memories_headline",
    no_digital_memories_text: "no_digital_memories_text",
    no_digital_memories_link_text: "no_digital_memories_link_text",
    no_digital_memories_link_url: "no_digital_memories_link_url",
    digital_memories_loading_video_text: "digital_memories_loading_video_text",
    digital_memories_loading_text: "digital_memories_loading_text",
    digital_memories_bottles_collection_headline:
      "digital_memories_bottles_collection_headline",
    digital_memories_bottles_collection_link_text:
      "digital_memories_bottles_collection_link_text",
    digital_memories_bottles_collection_link_url:
      "digital_memories_bottles_collection_link_url",
  },
};
